import type { Opportunity } from '../types'

export const openOpportunityStages=Object.freeze(['discovery','qualified','proposal','decision'] as const)

export function filterOpportunities(records:readonly Opportunity[],query:string,stage:string='open'){
  const needle=query.trim().toLowerCase()
  return Object.freeze(records.filter(record=>{
    const stageMatch=stage==='all'||(stage==='open'?openOpportunityStages.includes(record.stage as typeof openOpportunityStages[number]):record.stage===stage)
    const text=`${record.name} ${record.organizationName} ${record.primaryContactName||''} ${record.nextAction||''}`.toLowerCase()
    return stageMatch&&(!needle||text.includes(needle))
  }).sort((left,right)=>(right.annualValueCents||0)-(left.annualValueCents||0)||left.organizationName.localeCompare(right.organizationName)))
}

export function opportunitySummary(records:readonly Opportunity[]){
  const open=records.filter(record=>openOpportunityStages.includes(record.stage as typeof openOpportunityStages[number]))
  return Object.freeze({open:open.length,pipelineCents:open.reduce((sum,record)=>sum+(record.annualValueCents||0),0),unassigned:open.filter(record=>!record.ownerUserId).length,missingNextAction:open.filter(record=>!record.nextAction||!record.nextActionDueAt).length})
}
